import type { Lead } from '@up2stay/up2promo-api-client';

/** True when the lead has been archived (`archivedAt` set). */
export function isLeadArchived(
  lead: Pick<Lead, 'archivedAt'> | null | undefined,
): boolean {
  return lead?.archivedAt != null && String(lead.archivedAt).length > 0;
}

/**
 * True when the lead is another member’s private record (not own, not assigned,
 * not workspace-shared, and workspace always-share is off).
 */
export function isOthersPrivateLeadForViewer(
  lead: Pick<Lead, 'userId' | 'assigneeUserId' | 'visibility'>,
  viewerUserId: string | null | undefined,
  workspaceLeadsAlwaysShared?: boolean,
): boolean {
  if (workspaceLeadsAlwaysShared === true) return false;
  const viewer = viewerUserId?.trim() ?? '';
  if (!viewer) return false;
  const owner = lead.userId?.trim() ?? '';
  const assignee = lead.assigneeUserId?.trim() ?? '';
  if (owner === viewer || assignee === viewer) return false;
  return lead.visibility === 'private';
}

/**
 * `leads:update` for own / assigned / shared; also `leads:update_others` when
 * the lead is someone else’s private.
 */
export function canMutateLeadRecord(opts: {
  lead: Pick<Lead, 'userId' | 'assigneeUserId' | 'visibility'> | undefined;
  viewerUserId: string | null | undefined;
  canUpdate: boolean;
  canUpdateOthers: boolean;
  workspaceLeadsAlwaysShared?: boolean;
}): boolean {
  if (!opts.lead || !opts.canUpdate) return false;
  if (
    isOthersPrivateLeadForViewer(
      opts.lead,
      opts.viewerUserId,
      opts.workspaceLeadsAlwaysShared,
    )
  ) {
    return opts.canUpdateOthers;
  }
  return true;
}
